import {IUser} from './core/_model'
import {useUserListProvider} from './UserListProvider'

type Props = {
  user: IUser
}

const UserInfoCell = ({user}: Props) => {
  const {handleUserDetails} = useUserListProvider()

  return (
    <div>
      <button
        className='btn btn-link pb-0 text-info text-hover-primary'
        onClick={() => handleUserDetails(user)}
      >
        {user.user_full_name ? user.user_full_name : 'Unknown'}({' '}
        <span className='fw-bold fs-6'>{user.username ? user.username : 'Unknown'}</span>)
      </button>
      <div className='d-flex justify-content-start flex-column'>
        <span className='fw-semibold text-gray-700 d-block fs-6'>{user.userEmail}</span>
        <span className='text-gray-700 fw-semibold d-block fs-6'>{user.userMobile}</span>
      </div>
    </div>
  )
}

export default UserInfoCell
